// extracted by mini-css-extract-plugin
export var apps = "Steps-module--apps--28b06";
export var badge = "Steps-module--badge--ef807";
export var btn = "Steps-module--btn--6f71e";
export var btnOutlinePrimary = "Steps-module--btn-outline-primary--73742";
export var btnPrimary = "Steps-module--btn-primary--701bb";
export var footer = "Steps-module--footer--c4f26";
export var formSelect = "Steps-module--form-select--92524";
export var heading = "Steps-module--heading--97101";
export var inner = "Steps-module--inner--28092";
export var link = "Steps-module--link--8daa3";
export var list = "Steps-module--list--622fc";
export var section = "Steps-module--section--1d960";
export var step = "Steps-module--step--ebd6f";
export var stepContent = "Steps-module--stepContent--de8a3";
export var stepMedia = "Steps-module--stepMedia--4a085";
export var stepText = "Steps-module--stepText--30f04";
export var stepTitle = "Steps-module--stepTitle--c01da";